
import { Vue, Component, Prop } from "vue-property-decorator";
import ClickOutside from "vue-click-outside";

@Component({
  // do not forget this section
  directives: {
    ClickOutside,
  },
})
export default class TableChips extends Vue {
  show: boolean = false;

  toggle(): void {
    this.show = !this.show;
  }

  hide(): void {
    this.show = false;
  }
}
